function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PureComponent } from "react";
import TitleOnlyParagraph from "segments/desktop/core-components/title-only-paragraph/title-only-paragraph";
import Reviews from "segments/desktop/core-components/reviews/reviews";
import ReviewCardDefaultProps from "segments/desktop/core-components/review-card/default-props";
import { StyledWithTitleReviewsComponent } from "./with-title-reviews-component.scss";
class WithTitleReviewsComponent extends PureComponent {
    render() {
        const { reviews, titleOnlyParagraph, cardFontSize, reviewCardOverrideHeight, minHeight } = this.props;
        return /*#__PURE__*/ _jsxs(StyledWithTitleReviewsComponent, {
            className: "with-title-reviews-component",
            style: {
                minHeight
            },
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "title-only-paragrph-component-wrapper",
                    children: /*#__PURE__*/ _jsx(TitleOnlyParagraph, _object_spread({}, titleOnlyParagraph))
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "review-cards-wrapper",
                    children: /*#__PURE__*/ _jsx(Reviews, {
                        cardFontSize: cardFontSize,
                        reviews: reviews,
                        reviewCardOverrideHeight: reviewCardOverrideHeight
                    })
                })
            ]
        });
    }
}
export { WithTitleReviewsComponent as default };
WithTitleReviewsComponent.defaultProps = _object_spread_props(_object_spread({
    titleOnlyParagraph: _object_spread_props(_object_spread({}, TitleOnlyParagraph.defaultProps), {
        title: "Why Teams love monday.com"
    })
}, Reviews.defaultProps), {
    paddingTop: "92px",
    paddingBottom: "92px",
    cardFontSize: ReviewCardDefaultProps.fontSize,
    reviewCardOverrideHeight: null
});
